var list = $('.vendor-list'),
    items = $('.vendor-list-item', list);

// sort the list
var sortedItems = items.get().sort(function(a, b) {
  var aText = $.trim($(a).text().toUpperCase()),
      bText = $.trim($(b).text().toUpperCase());
  
   return aText.localeCompare(bText);
});

list.append(sortedItems); 

// create the titles
var lastLetter = '';
list.find('.vendor-list-item').each(function() {
  var $this = $(this),
      text = $.trim($this.text()),
      firstLetter = text[0];

  if (firstLetter != lastLetter) {
    $this.before('<li class="splitter">' + firstLetter);
    lastLetter = firstLetter;
  }
});
  

  $(document).ready(function() {

  $('.splitter').
     each(function() {
       $(this).
           nextUntil('.splitter').
           addBack().
           wrapAll('<div class="brand-wrap" />');
     });
});